import { useEffect } from 'react';
import PropTypes from 'prop-types';
import { Card, CardContent } from '@mui/material';
import Grid from '@mui/material/Unstable_Grid2';
import SubmitButton, { useCustomFormik } from 'src/components/formik-helper';
import StringTextField from 'src/components/widgets/string-textfield';
import QuillEditor from 'src/components/quill-editor';
import DropdownPlates from 'src/components/dropdown/dropdown-plates';
import DateAndTimePicker from 'src/components/widgets/date-time-picker';
import { MobileDateTimePicker } from '@mui/x-date-pickers/MobileDateTimePicker';
import {
  initialValues,
  validationSchema,
  handleSubmitted,
  formatWithCommas,
} from './formik';

export const DetailForm = (props) => {
  const {
    item,
    apiCreate,
    apiUpdate,
    apiRemove,
    ...other
  } = props;

  const editorRef = useRef();

  useEffect(() => {
    initialValues(formik, item);
  }, [item]);

  const formik = useCustomFormik({
    // initialValues: initialValues(item),
    validationSchema: validationSchema(item),

    onSubmit: async (values, helpers) => {
      const updatedValues = {
        ...values,
        note: editorRef.current?.getValue() || '',
      };

      await handleSubmitted(updatedValues, item, apiCreate, apiUpdate, apiRemove);

      // helpers.setStatus({ success: false });
      // helpers.setErrors({ submit: error });
      // helpers.setSubmitting(false);
    },
  });

  return (
    <form onSubmit={formik.handleSubmit} {...other}>
      <Card>
        <CardContent sx={{ px: 1, py: 2 }}>
          <Grid container spacing={3} alignItems="flex-start">
            <Grid xs={12} md={4}>
              <DropdownPlates formik={formik} />
            </Grid>
            <Grid xs={12} md={4}>
              <StringTextField
                label="ODO"
                name="odo"
                formik={formik}
                onChangeValue={(newValue) => {
                  return formatWithCommas(newValue);
                }}
                inputProps={{ maxLength: 10 }}
                hintValue={item.lastKm}
              />
            </Grid>
            <Grid xs={12} md={4}>
              <DateAndTimePicker
                label="Thời gian"
                name="created"
                format="dd/MM/yyyy - HH:mm"
                formik={formik}
                hintValue={item.createdAt}
              >
                <MobileDateTimePicker ampm={false} />
              </DateAndTimePicker>
            </Grid>
            
            <Grid xs={12} md={12}>
              <QuillEditor
                ref={editorRef}
                value={item.note}
                sx={{ height: 130 }}
              />
            </Grid>
          </Grid>
        </CardContent>

        <SubmitButton formik={formik} isRemove={item || false} />
      </Card>
    </form>
  );
};

DetailForm.propTypes = {
  item: PropTypes.object.isRequired,
  apiCreate: PropTypes.func,
  apiUpdate: PropTypes.func,
  apiRemove: PropTypes.func,
};